import React, { useState, useEffect } from 'react';
import {
  Box,
  Alert,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from '@mui/material';
import axios from 'axios';
import { formatDate } from '../utils/dateFormat';

const EmailCampaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/email/campaigns', {
        params: { limit: 100 },
      });
      setCampaigns(response.data);
    } catch (err) {
      setError('Failed to load email campaigns');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Run Date</TableCell>
                <TableCell>Campaign Type</TableCell>
                <TableCell>Tours Processed</TableCell>
                <TableCell>Emails Sent</TableCell>
                <TableCell>Emails Failed</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {campaigns.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography color="text.secondary">
                      No campaigns found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                campaigns.map((campaign) => (
                  <TableRow key={campaign.id}>
                    <TableCell>{formatDate(campaign.run_date)}</TableCell>
                    <TableCell>{campaign.campaign_type}</TableCell>
                    <TableCell>{campaign.total_tours_processed}</TableCell>
                    <TableCell>
                      <Chip
                        label={campaign.total_emails_sent}
                        color="success"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {campaign.total_emails_failed > 0 ? (
                        <Chip
                          label={campaign.total_emails_failed}
                          color="error"
                          size="small"
                        />
                      ) : (
                        <Typography variant="body2">0</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          campaign.total_emails_failed > 0
                            ? 'Partial'
                            : campaign.total_emails_sent > 0
                            ? 'Complete'
                            : 'No Emails'
                        }
                        color={
                          campaign.total_emails_failed > 0
                            ? 'warning'
                            : campaign.total_emails_sent > 0
                            ? 'success'
                            : 'default'
                        }
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default EmailCampaigns;



